module.exports = require('./helpers/bundle-url').getBundleURL('4ifA7') + "favicon.c4f0b39d.gif";